import { VFC } from 'react';

import Spinner from '@/components/Spinner';

import styles from './DefaultSpinner.module.scss';

/**
 * show large spinner
 */

const DefaultSpinner: VFC = () => {
  return (
    <div className={styles.spinner}>
      <Spinner size="1.1em" />
    </div>
  );
};

export default DefaultSpinner;
